import api from './api';

export interface NacReportSummary {
  id: number;
  period: string;
  companyName: string;
  summaryContent: string | null;
  updateUser: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface NodeStatus1Item {
  node_type: string;
  current_count: number;
  prev_count: number;
  diff: number;
  diff_text: string;
  ratio: string;
}

export interface NodeStatus2Item {
  policy_name: string;
  current_count: number;
  prev_count: number;
  diff: number;
  diff_text: string;
  ratio: string;
}

export interface NodeStatus3Item {
  os_category: string;
  current_count: number;
  prev_count: number;
  diff: number;
  diff_text: string;
  ratio: string;
}

export interface NodeStatus4Item {
  platform: string;
  current_count: number;
  prev_count: number;
  diff: number;
  diff_text: string;
  ratio: string;
}

export const nacService = {
  // Period 관련
  getAvailablePeriods: async (): Promise<string[]> => {
    const response = await api.get<string[]>('/nac/periods');
    return response.data;
  },

  // 인가된 회사 목록
  getPermittedCompanies: async (): Promise<string[]> => {
    const response = await api.get<string[]>('/nac/report/permitted-companies');
    return response.data;
  },

  // Report Summary
  getSummary: async (period: string, companyName: string): Promise<NacReportSummary | null> => {
    const response = await api.get('/nac/report/summary', {
      params: { period, companyName },
    });
    return response.data;
  },

  saveSummary: async (
    period: string,
    companyName: string,
    summaryContent: string,
  ): Promise<NacReportSummary> => {
    const response = await api.post('/nac/report/summary', {
      period,
      companyName,
      summaryContent,
    });
    return response.data;
  },

  // 노드현황 1: NAC 전체노드
  getNodeStatus1: async (
    period: string,
    companyName: string,
    prevPeriod?: string,
  ): Promise<NodeStatus1Item[]> => {
    const response = await api.get<NodeStatus1Item[]>('/nac/report/node-status-1', {
      params: { period, companyName, prevPeriod },
    });
    return response.data;
  },

  // 노드현황 2: PC별 정책 현황
  getNodeStatus2: async (
    period: string,
    companyName: string,
    prevPeriod?: string,
  ): Promise<NodeStatus2Item[]> => {
    const response = await api.get<NodeStatus2Item[]>('/nac/report/node-status-2', {
      params: { period, companyName, prevPeriod },
    });
    return response.data;
  },

  // 노드현황 3: PC별 운영체제 요약
  getNodeStatus3: async (
    period: string,
    companyName: string,
    prevPeriod?: string,
  ): Promise<NodeStatus3Item[]> => {
    const response = await api.get<NodeStatus3Item[]>('/nac/report/node-status-3', {
      params: { period, companyName, prevPeriod },
    });
    return response.data;
  },

  // 노드현황 4: 운영체제별 PC 노드
  getNodeStatus4: async (
    period: string,
    companyName: string,
    prevPeriod?: string,
  ): Promise<NodeStatus4Item[]> => {
    const response = await api.get<NodeStatus4Item[]>('/nac/report/node-status-4', {
      params: { period, companyName, prevPeriod },
    });
    return response.data;
  },

  // 비고 관리
  getStatNotes: async (
    period: string,
    companyName: string,
    statType: string,
  ): Promise<Record<string, string>> => {
    const response = await api.get<Record<string, string>>('/nac/report/stat-notes', {
      params: { period, companyName, statType },
    });
    return response.data;
  },

  saveStatNote: async (
    period: string,
    companyName: string,
    statType: string,
    statKey: string,
    note: string,
  ): Promise<any> => {
    const response = await api.post('/nac/report/stat-notes', {
      period,
      companyName,
      statType,
      statKey,
      note,
    });
    return response.data;
  },

  // Publish 관련
  getPublishStatus: async (period: string, companyName: string): Promise<boolean> => {
    const response = await api.get<{ published: boolean }>('/nac/report/publish-status', {
      params: { period, companyName },
    });
    return response.data.published;
  },

  publish: async (period: string, companyName: string): Promise<any> => {
    const response = await api.post('/nac/report/publish', {
      period,
      companyName,
    });
    return response.data;
  },
};

